import { useAuth } from "../../../../context/AuthContext";
import defaultProfilePic from "../../../../assest/defaultProfile.png";
import { FaPen } from "react-icons/fa";

// ProfileFormPreview component displays the user's profile information and allows editing of the profile by clicking on the edit icon.
// It also displays the user's job status and related information.
//  If the user is not logged in, it displays a "Loading..." message.
const ProfileFormPreview = ({ setIsFormVisible, setIsUpdating }) => {
  const { user } = useAuth();

  //   Handles the "Edit" button click by setting the isFormVisible state to true
  //   and setting the isUpdating state to true.
  const handleEdit = () => {
    setIsFormVisible(true);
    setIsUpdating(true);
  };

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <div className="profile-preview">
      <div
        className="avatar-section"
        style={{
          overflow: "hidden",
          display: "flex",
        }}
      >
        {user.profilePicture ? (
          <img src={user.profilePicture} alt="Profile Pic" />
        ) : (
          <img src={defaultProfilePic} alt="Profile Pic" />
        )}
      </div>
      <div className="details-section">
        <FaPen className="penicon" onClick={() => handleEdit()} />
        <h3>
          {user.firstName} {user.lastName}
        </h3>
        <h4>{user.jobStatus} </h4>
        <div className="personal-info">
          <p>
            <strong>About:</strong> {user.bio}
          </p>
          <p>
            <strong>Age:</strong> {user.age}
          </p>
          <p>
            <strong>Gender:</strong> {user.gender}
          </p>
          {user.jobStatus === "student" && (
            <div className="job-staus-information">
              <p>
                <strong>University Name:</strong> {user.universityName}
              </p>
              <p>
                <strong>Degree Name:</strong> {user.degreeName}
              </p>
              <p>
                <strong>Year:</strong> {user.GraduationYear}
              </p>
            </div>
          )}
          {user.jobStatus === "employed" && (
            <div className="job-staus-information">
              <p>
                <strong>Company Name:</strong> {user.companyName}
              </p>
              <p>
                <strong>Role:</strong> {user.role}
              </p>
              <p>
                <strong>Description:</strong> {user.desc}
              </p>
            </div>
          )}
          {user.jobStatus === "self-employed" && (
            <div className="job-staus-information">
              <p>
                <strong>Company Name:</strong> {user.companyName}
              </p>
              <p>
                <strong>Role:</strong> {user.role}
              </p>
              <p>
                <strong>Description:</strong> {user.description}
              </p>
            </div>
          )}
          {user.jobStatus === "unemployed" && (
            <p>
              <strong>Preference Role:</strong> {user.preferenceRole}
            </p>
          )}
          <p>
            <strong>Social Link:</strong>
            {user?.socialLink &&
              Object.entries(user.socialLink).map(([platform, link]) => (
                <div key={platform}>
                  {platform}:{link}
                </div>
              ))}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileFormPreview;
